var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
        'relative inline-flex items-center justify-center flex-shrink-0 overflow-hidden select-none bg-theme-primary',
        _vm.sizeClass,
        _vm.circle ? 'rounded-full' : 'rounded-lg',
        _vm.pointer ? 'cursor-pointer' : ''
    ]},[_vm._t("default"),(_vm.badge)?_c('span',{class:[
            'absolute bottom-0 right-0 w-2.5 h-2.5 rounded-full border-2 border-theme-card',
            _vm.badgeColorClass
        ]}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }